import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";

import userReducer from "./reducers/userReducer";
import listReducer from "./reducers/listReducer";
import saleReducer from "./reducers/saleReducer";
import buyReducer from "./reducers/buyReducer";
import expenseReducer from "./reducers/expenseReducer";
import customerReducer from "./reducers/customerReducer";
import supplierReducer from "./reducers/supplierReducer";
import employeeReducer from "./reducers/employeeReducer";
import inventoryReducer from "./reducers/inventoryReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import utilityReducer from "./reducers/utilityReducer";
import cashBookReducer from "./reducers/cashBookReducer";
import incomeReducer from "./reducers/incomeReducer";
import debitCreditReducer from "./reducers/debitCreditReducer";
import businessReducer from "./reducers/bussinessReducer";
import chatReducer from "./reducers/chatReducer";
import ticketReducer from "./reducers/ticketReducer";
import rolePermission from "./reducers/rolePermissionReducer";
import PNLReportBasicFormatReducer from "./reducers/report/P&L Report - Basic Format.Reducer";
import InventoryReportdata from "./reducers/report/inventoryReoport";
import BasicPnl from "./reducers/report/PnlBasic";
import TrendPnl from "./reducers/report/PnlTrend";
import PnlCustomerPending from "./reducers/report/PnlCustomerPending";
import supplierPending from "./reducers/report/pnlSupplierPending";
import CustomeSaleReport from "./reducers/report/CustomeSaleReport";
import CustomePurchesReport from "./reducers/report/CustomePurchesReport";
import CustomeInventoryReport from "./reducers/report/CustomeInventoryReport";
import CustomeExpenseReport from "./reducers/report/CustomeExpenseReport";

import CustomeCustomerReport from "./reducers/report/CustomeCustomerReport";

import CustomeSupplierReport from "./reducers/report/CustomeSupplierReport";

import SaleReportSaleTrand from "./reducers/report/SaleReportSaleTrand";

import salereportbypercentage from "./reducers/report/SaleReportSaleReportByPercent";
import salereporttrend from "./reducers/report/SaleReportReporttrend";
import salereportinvoice from "./reducers/report/SaleReportInvoice";
import ReturnTrend from "./reducers/report/ReturnReportTrend";
import Returnbypercentage from "./reducers/report/ReturnPercentage";
import CustomerReportCustomer from "./reducers/report/CustomerReport";
import PurchaseTreand from "./reducers/report/PurchaseTreandReport";
import PurchaseStatus from "./reducers/report/PurchaseStatusReport";
import GstR1Report from "./reducers/report/GstR1Report";
import GstR2Report from "./reducers/report/GstR2Report";
import GstR3BReport from "./reducers/report/GstR3BReport";

import ExpenseTrend from "./reducers/report/ExpenseTrendReport";
import manufacturingReducer from "./reducers/report/manufactureReducer";
import RawMatarial from "./reducers/rawMatrialReducer";
import RawMatarialReport from "./reducers/report/RawMatarialReport"
import WarehouseReport from "./reducers/report/WarehouseReport"
import warehouseStatusCountReport from "./reducers/report/warehouseStatusCountReport"
import reviewReducer from "./reducers/reviewReducer";
import couponReducer from "./reducers/couponReducer";
import wishlistReducer from "./reducers/wishlistReducer";
export default configureStore({
  reducer: {
    user: userReducer,
    lists: listReducer,
    sales: saleReducer,
    buys: buyReducer,
    expenses: expenseReducer,
    customers: customerReducer,
    suppliers: supplierReducer,
    employees: employeeReducer,
    inventory: inventoryReducer,
    dashboard: dashboardReducer,
    utility: utilityReducer,
    cashBook: cashBookReducer,
    income: incomeReducer,
    notes: debitCreditReducer,
    bussiness: businessReducer,
    chatuser: chatReducer,
    tickets: ticketReducer,
    rolePermission: rolePermission,
    PNLReportBasicFormatReducer: PNLReportBasicFormatReducer,
    InventoryReportdata: InventoryReportdata,
    BasicPnl: BasicPnl,
    TrendPnl: TrendPnl,
    PnlCustomerPending: PnlCustomerPending,
    supplierPending: supplierPending,
    CustomeSaleReport: CustomeSaleReport,
    CustomePurchesReport: CustomePurchesReport,
    CustomeInventoryReport: CustomeInventoryReport,
    CustomeExpenseReport: CustomeExpenseReport,
    CustomeCustomerReport: CustomeCustomerReport,
    CustomeSupplierReport: CustomeSupplierReport,
    SaleReportSaleTrand: SaleReportSaleTrand,
    salereportbypercentage: salereportbypercentage,
    salereporttrend: salereporttrend,
    salereportinvoice: salereportinvoice,
    ReturnTrend: ReturnTrend,
    Returnbypercentage: Returnbypercentage,
    CustomerReportCustomer: CustomerReportCustomer,
    PurchaseTreand: PurchaseTreand,
    PurchaseStatus: PurchaseStatus,
    GstR1Report: GstR1Report,
    GstR2Report: GstR2Report,
    GstR3BReport: GstR3BReport,

    ExpenseTrend: ExpenseTrend,
    manufacturing: manufacturingReducer,
    RawMatarial: RawMatarial,
    RawMatarialReport: RawMatarialReport,
    WarehouseReport: WarehouseReport,
    warehouseStatusCountReport:warehouseStatusCountReport,
    reviews: reviewReducer,
    coupons : couponReducer,
    wishlist: wishlistReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
